export const onConfirmDialogConfirm = () => ({
  widget: 'tokens',
  type: 'onConfirmDialogConfirm',
  payload: {},
})



// WEBPACK FOOTER //
// ./src/tokens/actions/onConfirmDialogConfirm.js